import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: HomeView
  },
  {
    path: '/contractFile',
    name: 'contractFile',
    component: function () {
      return import('@/views/home/contractFile.vue')
    },
    meta:{title:'合同回执',showMenu:true}
  },
  {
    path: '/home',
    name: 'indexs',
    component: function () {
      return import('@/views/home/indexs.vue')
    },
    meta:{title:'绩效考评',showMenu:true}
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: function () {
      return import('@/views/home/privacyAgreement.vue')
    },
    meta:{title:'隐私政策'}
  },
  {
    path: '/termsToService',
    name: 'termsToService',
    component: function () {
      return import('@/views/home/termsToService.vue')
    },
    meta:{title:'用户协议'}
  },
  {//一杞做伴
    path: '/privacyAgreement1',
    name: 'privacyAgreement1',
    component: function () {
      return import('@/views/home/privacyAgreement1.vue')
    },
    meta:{title:'隐私政策'}
  },
  {//一杞做伴
    path: '/termsToService1',
    name: 'termsToService1',
    component: function () {
      return import('@/views/home/termsToService1.vue')
    },
    meta:{title:'用户协议'}
  },
  {//小程序
    path: '/termsToService2',
    name: 'termsToService2',
    component: function () {
      return import('@/views/home/termsToService2.vue')
    },
    meta:{title:'用户协议'}
  },
  {//小程序
    path: '/privacyAgreement2',
    name: 'privacyAgreement2',
    component: function () {
      return import('@/views/home/privacyAgreement2.vue')
    },
    meta:{title:'隐私政策'}
  },
  {
    path: '/gysPrivacyAgreement',
    name: 'gysPrivacyAgreement',
    component: function () {
      return import('@/views/home/gysPrivacyAgreement.vue')
    },
    meta:{title:'隐私协议'}
  },
  {
    path: '/gysTermsToService',
    name: 'gysTermsToService',
    component: function () {
      return import('@/views/home/gysTermsToService.vue')
    },
    meta:{title:'服务条款'}
  },
  {
    path: '/register',
    name: 'register',
    component: function () {
      return import('@/views/home/register.vue')
    },
    meta:{title:'用户注册'}
  },
  {
    path: '/supplierRegister',
    name: 'register',
    component: function () {
      return import('@/views/home/supplierRegister.vue')
    },
    meta:{title:'用户注册'}
  },
  {
    path: '/quote/:q/:s?',
    name: 'quote',
    component: function () {
      return import('@/views/home/quote.vue')
    },
    meta:{title:'采购报价'}
  },
  {
    path: '/ms/:id?',
    name: 'ms',
    component: function () {
      return import('@/views/home/ms.vue')
    },
    meta:{title:'杞里香面试信息登记表'}
  },
  {
    path: '/InterviewRegistration',
    name: 'ms',
    component: function () {
      return import('@/views/home/ms.vue')
    },
    meta:{title:'杞里香面试信息登记表'}
  },
  {
    path: '/wj/:id?/:isNeedLogin?',
    name: 'wj',
    component: function () {
      return import('@/views/home/wj.vue')
    },
    meta:{title:'杞里香问卷调查表'}
  },
  {
    path: '/accomplish',
    name: 'accomplish',
    component: function () {
      return import('@/views/home/accomplish.vue')
    },
    meta:{title:'杞里香'}
  },
  {
    path: '/signManual/:phone/:id/:tokens',
    name: 'signManual',
    component: function () {
      return import('@/views/home/signManual.vue')
    },
    meta:{title:'签署员工手册'}
  },
  {
    path: '/upload/:tokens/:uuids',
    name: 'upload',
    component: function () {
      return import('@/views/home/upload.vue')
    },
    meta:{title:'上传图片'}
  },
  {
    path: '/faceRecognition',
    name: 'faceRecognition',
    component: function () {
      return import('@/views/fare-recognition/index.vue')
    },
    meta:{title:'人脸识别'}
  },
  //app页面跳转
  {
    path: '/oa/open',
    name: 'OpenApp',
    component: function () {
      return import('@/views/oa/open.vue')
    },
    meta:{title:'页面跳转'}
  },
  {
    path: '/gys/open',
    name: 'gysOpenApp',
    component: function () {
      return import('@/views/gys/open.vue')
    },
    meta:{title:'页面跳转'}
  },
]
const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if(to.path == '/'){
    next();		
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});


export default router
